module.exports = __webpack_public_path__ + "img/shopping-grey.b090a996.svg";